{
  "version": 1,
  "asset_id": "483701ca-9b6e-476e-85f0-8c52f095ad34",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/483701ca-9b6e-476e-85f0-8c52f095ad34/clip-img_0011-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/483701ca-9b6e-476e-85f0-8c52f095ad34/clip-img_0011-poster-sm.webp",
  "original_filename": "clip-img_0011-poster-sm.webp",
  "size": 23674,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:00Z"
}
